import { ActionContext } from 'vuex';

import IState from '@/interfaces/IState';
import ITrafficSource from '@/interfaces/ITrafficSource';
import router from '@/router';

export default async (context: ActionContext<IState, IState>, trafficSourceData:ITrafficSource) => {
    if (!trafficSourceData) {
        return Promise.reject('Incorrect traffic Source data');
    }
    try {
        const trafficSource = await context.dispatch('backendTalker', {
            request: 'traffic_source_update',
            data: trafficSourceData
        });
        if (trafficSource.status === 200) {
            await context.dispatch('trafficSourcesList')
            router.push({ name: 'traffic_sources' });
        } else {
            return Promise.reject(trafficSource.status);
        }
    } catch (err) {
        return Promise.reject(err);
    }
};
